export default __webpack_public_path__ + "static/media/gdpr-internxt.d7d2ee60.svg";